/**
 * @file
 * Generate vendor script file.
 *
 * This file includes all needed JS partials from third-party node modules.
 */

//=require select2/dist/js/select2.js
//=require select2/dist/js/i18n/de.js
//=require jquery-match-height/dist/jquery.matchHeight.js
//=require lightbox2/dist/js/lightbox.min.js
//=require slick-carousel/slick/slick.js
//=require ./rollup/d3.js